import { defineMessages } from 'react-intl';

export default defineMessages({
  'editButton.text': {
    id: 'alarmLevelsButton.editButton.text',
    defaultMessage: 'Edit'
  }
});